<template>
  <div style="width:100%">
    <v-layout>
      <v-flex xs3>
        <v-card
            class="mx-auto"
            width="250"
          >
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Home</v-list-item-title>
              </v-list-item>
            <v-list-item
                link
                @click="selectGroup({orgUnitPath: '/Students'})"
              >
              <v-list-item-title>All Students</v-list-item-title>
              </v-list-item>
              <v-list-group
                value="true"
              >
                <template v-slot:activator>
                  <v-list-item-title>Groups</v-list-item-title>
                </template>

                <v-list-item
                    v-for="(group, i) in groups"
                    :key="i"
                    link
                    @click="selectGroup(group)"
                  >
                  <v-list-item-title v-text="group.name"></v-list-item-title>
                  <span style="font-size:.8em">{{ group.directMembersCount }}</span>
                  </v-list-item>
              </v-list-group>

              <v-list-item
                  link
                  @click="selectInactive"
                >
                <v-list-item-title>Inactive Accounts</v-list-item-title>
                </v-list-item>
            </v-list>

          </v-card>
          <v-card
              class="mt-10 mx-auto"
              width="250"
            >
            <v-card-text>
            Students without OSIS have not been added the DB Student Accounts. Visit the New Students to manage new OSIS mappings.
          </v-card-text>
            </v-card>
      </v-flex>
      <v-flex xs9>
        <v-text-field
                label="Solo"
                placeholder="Filter..."
                v-model="table.search"
                solo
              ></v-text-field>
        <v-card>

        </v-card>
        <v-data-table
          :loading="table.loading"
          :headers="table.headers"
          :items="items"
          :dense="true"
          :items-per-page="100"
          :search="table.search"
          :sort-by="['name']"
          :hide-default-footer="false"
          :disable-pagination="false"
          :height="700"
        >
        <template v-slot:item="props">
          <tr>
            <td style="font-size:.8em" class="text-xs">
                {{ props.item.name.fullName }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.primaryEmail.split("@")[0] }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.osis }}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.orgUnitPath.replace("/Students/",'')}}
            </td>
            <td style="font-size:.8em" class="text-xs">
              {{ props.item.status }}
            </td>
            <td style="font-size:.8em">
              {{ props.item.lastLoginTime | moment("YYYY-MM-DD h:mma") }}
            </td>
            <td class="text-xs-center">
              <v-btn
                x-small
                link
                text
                target="_blank"
                :href="'https://admin.google.com/u/4/ac/search?query=' + props.item.primaryEmail  +'&tab=USERS&hl=en'"
              >G Admin </v-btn>
            </td>

          </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const api = require('../apiFunctions.js')
const fb = require('../firebaseConfig.js')

export default {
  data: () => ({
    user: fb.session.user,
    groups: [],
    params: {
      user_uid: '',
      target: '',
      table: '',
      limit: 100
    },
    items: [],
    table: {
      loading: false,
      search: '',
      headers: [
        { text: 'Name', value: 'name.fullName' },
        { text: 'Email', value: 'primaryEmail' },
        { text: 'OSIS', value: 'osis' },
        { text: 'Org', value: 'orgUnitPath' },
        { text: 'Status', value: 'status' },
        { text: 'Last sign in', value: 'lastLoginTime' },
        { text: '', value: '' }
      ]
    }
  }),
  watch: {
  },
  mounted () {
    var self = this
    api.get('getAccountGroups', {}, (data) => {
      console.log(data)
      data.organizationUnits.forEach((item, i) => {
        if (item.orgUnitPath.indexOf("Students/") != -1) {
          item.year = 0
          let matches = item.name.match(/(\d+)/)
          if (matches) {
            item.year = parseInt(matches[0])
          }
          self.groups.push(item)
        }
      });
      self.groups.sort((a, b)=> {return b.year-a.year})
    })
  },
  methods: {
    selectGroup: function (group) {
      var self = this
      self.table.loading = true
      self.items = []
      api.get('getGSuiteAccounts', {orgKey:group.orgUnitPath, cache: false }, (data) => {
        self.items = data
        self.table.loading = false
        console.log(data)
      })
    },
    selectInactive: function (group) {
      var self = this
      self.table.loading = true
      self.items = []
      api.get('getGSuiteAccounts', {orgKey:'/Students', cache: false }, (data) => {
        self.items = data.filter((item)=>{
          return !item.active
        })
        self.table.loading = false
        console.log(data)
      })
    },
    viewClasses: function (student) {
      console.log(student)
      this.$router.push({ path: '/classes/all', query: { studentId: student.primaryEmail }})
    },
    search: function () {
      var self = this
      console.log(this.params)
      api.students.get(this.params, (data) => {
        console.log(data)
        self.items = data
      })
    }
  }
}
</script>
